// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Chevron gauche epais, SANS fut : le « retour ». Glyphe plus haut que large
 * (131.04 x 226.83), donc centre dans sa boite carree. Source `left_back.svg`.
 */
export const IconLeftBack = createCustomIcon(
  'IconLeftBack',
  '0 0 131.04 226.83',
  <polygon
    fill="currentColor"
    points="131.04 209.13 113.43 226.83 0 113.42 113.45 0 130.97 17.79 35.35 113.42 131.04 209.13"
  />,
);
